/* Kategorieseiten: Artikel beim Scrollen automatisch nachladen (ersetzt Klick auf „Weitere Artikel laden“) */
(function(){
  var timer=null;
  function check(){
    timer=null;
    var boxes=document.querySelectorAll('[data-rd-more]');
    for(var i=0;i<boxes.length;i++){
      var b=boxes[i].querySelector('button');
      if(b && boxes[i].getBoundingClientRect().top < window.innerHeight + 800){ b.click(); }
    }
  }
  function tick(){ if(!timer) timer=setTimeout(check,60); }
  window.addEventListener('scroll',tick,{passive:true});
  window.addEventListener('resize',tick);
  function start(){
    tick();
    var boxes=document.querySelectorAll('[data-rd-more]');
    if(window.MutationObserver){ for(var i=0;i<boxes.length;i++){ new MutationObserver(tick).observe(boxes[i],{childList:true,subtree:true}); } }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start)}else{start()}
})();
